export const TACTICAL_OPTION = 'tactical';
export const ATHLETE_OPTION = 'athlete';

export const TAG_OPTION = 'tag';
export const TIMING_OPTION = 'timing';

export const YES_OPTION = 'yes';
export const NO_OPTION = 'no';

export const TAG_TYPE_OPTION = 'tag_type';
export const LABELS_WITHIN_TAG_OPTION = 'labels_within_tag';

export const LEARN_MORE_LINK = 'https://support.catapultsports.com/hc/en-us/articles/9714724326415';
